var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBronzePodium = function SvgBronzePodium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 70,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bronzePodium_svg__a)",
    d: "M0 0h94a4 4 0 0 1 4 4v12H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4435C",
    d: "M0 16h98v55H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bronzePodium_svg__b)",
    d: "M0 16h98v55H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.744 36.648c0 1.792-.832 3.36-2.273 4.448 1.793 1.216 2.88 3.072 2.88 5.28 0 4.064-3.584 6.976-8.224 6.976-4.32 0-7.84-2.624-8.128-6.24l4.064-.32c.416 1.76 2.112 2.912 4.064 2.912 2.496 0 4.352-1.472 4.352-3.488s-1.855-3.456-4.352-3.456h-1.184l.032-3.168h1.152c2.208 0 3.808-1.248 3.808-2.944s-1.632-2.976-3.872-2.976c-1.568 0-3.104.736-3.68 2.08l-3.904-.256c.513-3.04 3.648-5.28 7.584-5.28 4.48 0 7.68 2.688 7.68 6.432"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bronzePodium_svg__a",
    x1: 47.515,
    x2: 47.515,
    y1: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6BDAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bronzePodium_svg__b",
    x1: 102.455,
    x2: 0,
    y1: 34,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#172940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C6AA6"
  })))));
};
export default SvgBronzePodium;